module.exports = __webpack_public_path__ + "img/zagazighospital.d33cb6a8.jpg";